/* eslint-disable react-hooks/exhaustive-deps */
import { get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { editReservations } from '../../apis/admin/seminar';
import useForm from '../../hooks/useForm';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';
import Form from '../Form';
import Modal, { ModalHeader } from '../Modal';
import { seminarRecruitments } from '../../apis/admin/seminar';
import { dateToFormat, formatDateHour } from '../../utils/date';

const defaultForm = {
  approvalStatus: "wait",
  paymentStatus: "false",
  companyName: '',
};
const Reservation = (props) => {
  const { open, setOpen, submit, selectedItem, setSelectedItem } = props;


  const [fields, setFields] = useState([]);

  const [seminars, setSeminars] = useState([]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };
  const _submit = (form) => {
    const data = {
      ...form,
      memo: form.memo || "",
      recruitmentIdx: form.recruitmentIdx,
      seminarStartTime: form.seminarStartTime[0],
      seminarEndTime: form.seminarEndTime[0],
    };

    systemAlert("결재 및 예약상태를 정말 변경하시겠습니까?",
      {
        buttons: [
          {
            label: "취소",
            color: "text",
          },
          {
            label: '변경',
            onClick: () => {
              editReservations(selectedItem.idx, data)
                .then(() => {
                  toast.success("변경되었습니다.");
                  cancel();
                  submit && submit();
                }).catch(err => {
                  console.error(err);
                });
            }
          }
        ]
      });
  };


  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    open && (
      seminarRecruitments({})
        .then((res) => {
          const list = res?.seminarRecruitments?.rows;
          setSeminars(list);
        }).catch((err) => {
          console.error(err);
        })
    );
  }, [open]);

  useEffect(() => {
    setValidateFields(fields);
    if (!isEmpty(selectedItem)) {
      setForm({
        ...selectedItem,
        paymentStatus: get(selectedItem, "paymentStatus") + "",
        recruitmentIdx: get(selectedItem, "recruitmentIdx") + "",

      });
      setOriginForm({
        ...selectedItem,
        paymentStatus: get(selectedItem, "paymentStatus") + "",
        recruitmentIdx: get(selectedItem, "recruitmentIdx") + "",
        seminarStartTime: [dateToFormat(selectedItem.seminarStartTime, formatDateHour)],
        seminarEndTime: [dateToFormat(selectedItem.seminarEndTime, formatDateHour)],
      });
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);

  useEffect(() => {
    const fields = [
      [
        {
          title: "세미나 선택",
          key: "recruitmentIdx",
          type: "select",
          options: {
            list: () => [
              ...seminars.map(item => {
                return {
                  label: `${item.title}(${dateToFormat(item.seminarStartTime, "YYYY-MM-DD HH:mm")} ~ ${dateToFormat(item.seminarEndTime, "YYYY-MM-DD HH:mm")})/${item.place}`, value: item.idx + ""
                };
              })
            ]
          },
        },
      ],
      [
        {
          title: "이름",
          key: "name",
          type: "input",
        },
        {
          title: "예약인원",
          key: "memberCnt",
          type: "number",
        },
      ],
      [
        {
          title: "상호명",
          key: "companyName",
          type: "input",
        },
      ],
      [
        {
          title: "연락처",
          key: "mobile",
          type: "input",
          validators: ["mobile"]
        },
        {
          title: "이메일",
          key: "email",
          type: "input",
          validators: ["email"]
        }
      ],
      [
        {
          title: "모임 시작시간",
          type: "datetimepicker",
          key: "seminarStartTime",
          required: true,
        },
        {
          title: "모임 종료시간",
          type: "datetimepicker",
          key: "seminarEndTime",
          required: true,
        },
      ],
      [
        {
          title: "예약상태",
          key: "approvalStatus",
          type: "select",
          options: {
            list: [
              { label: "대기", value: "wait" },
              { label: "예약대기", value: "reservationWait" },
              { label: "예약완료", value: "approval" },
              { label: "반려", value: "denied" },
            ]
          }
        },
        {
          title: "결재상태",
          key: "paymentStatus",
          type: "select",
          options: {
            list: [
              { label: "결제", value: "true" },
              { label: "미결재", value: "false" },
            ]
          }
        },
      ],

      {
        title: "추가 요청사항",
        key: "requestInfo",
        type: "textarea",
        readOnly: true,
      },

      {
        title: "메모",
        key: "memo",
        type: "textarea"
      }
    ];
    setFields(fields);
  }, [seminars, form?.recruitmentIdx && form.recruitmentIdx]);


  return (
    <Modal
      isOpen={open}
      close={cancel}
    >

      <div className="item-write">
        <ModalHeader>
          {`${selectedItem?.name}님 상태 변경`}
        </ModalHeader>

        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={"변경"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
};

export default Reservation;